"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _indexModule = _interopRequireDefault(require("../static/styles/index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind.default.bind(_indexModule.default);

let modalsShowing = 0;

function modalWillShow() {
  if (modalsShowing === 0 && document) {
    document.body.classList.add(cx("modal-open"));
  }

  modalsShowing += 1;
}

function modalWillHide() {
  modalsShowing -= 1;

  if (modalsShowing === 0 && document) {
    document.body.classList.remove(cx("modal-open"));
  }
}

class Modal extends _react.default.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "componentDidMount", () => {
      if (this.props.visible) {
        modalWillShow();
      }
    });

    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.visible !== prevProps.visible) {
        if (this.props.visible) {
          modalWillShow();
        } else {
          modalWillHide();
        }

        this.setState({
          visible: this.props.visible
        });
      }
    });

    _defineProperty(this, "componentWillUnmount", () => {
      if (this.props.visible) {
        modalWillHide();
      }
    });

    _defineProperty(this, "stopPropagation", event => {
      event.stopPropagation();
    });

    _defineProperty(this, "renderBackdrop", () => {
      if (this.state.visible || this.state.transitioning) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: cx('modal-backdrop', {
            show: this.state.visible
          }),
          onClick: this.props.onClickBackdrop,
          role: "presentation",
          style: {
            zIndex: 1040 + this.state.modalIndex
          }
        });
      }

      return null;
    });

    _defineProperty(this, "render", () => {
      const _this$props = this.props,
            wrapperProps = _this$props.wrapperProps,
            className = _this$props.className,
            dialogClassName = _this$props.dialogClassName,
            visible = _this$props.visible,
            onClickBackdrop = _this$props.onClickBackdrop,
            children = _this$props.children,
            other = _objectWithoutProperties(_this$props, ["wrapperProps", "className", "dialogClassName", "visible", "onClickBackdrop", "children"]);

      return /*#__PURE__*/_react.default.createElement("div", wrapperProps, /*#__PURE__*/_react.default.createElement("div", _extends({
        className: cx("modal", {
          show: this.state.visible
        }, className),
        style: {
          display: this.state.visible || this.state.transitioning ? "block" : "none",
          zIndex: 1040 + this.state.modalIndex + 1
        },
        role: "dialog",
        "aria-hidden": !this.state.visible,
        tabIndex: "-1",
        onClick: onClickBackdrop
      }, other), /*#__PURE__*/_react.default.createElement("div", {
        className: cx("modal-dialog", dialogClassName),
        role: "document",
        onClick: this.stopPropagation
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: cx("modal-content", "shadow-lg")
      }, " ", children, " "))), this.renderBackdrop());
    });

    this.state = {
      visible: this.props.visible,
      modalIndex: 0
    };
  }

}

var _default = Modal;
exports.default = _default;